// Import model
import { Door } from '../models/Door';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Point } from '../models/Point';

// Import dependency serializers (for complex types)
import { PointSerializer } from './PointSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Door - handles JSON serialization and deserialization with type validation
 */
export class DoorSerializer {
  /**
   * Deserializes a JSON string into a Door instance
   */
  static deserialize(json: string): Door {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Door instance
   */
  static fromObject(obj: any): Door {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Door');
    }


    const instance: Door = {
      addTransition: obj['addTransition'] as boolean | undefined,
      name: obj['name'] as string | undefined,
      trimDoor: obj['trimDoor'] as boolean | undefined,
      wallIndex: obj['wallIndex'] as number | undefined,
      widthUom: obj['widthUOM'] as string | undefined,
      width: obj['width'] as number | undefined,
      isOpening: obj['isOpening'] as boolean | undefined,
      offset: obj['offset'] as number | undefined,
      shape: obj['shape'] ? (obj['shape'] as any[]).map((item: any) =>
        PointSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Door instances
   */
  static deserializeArray(json: string): Door[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Door instance to a JSON string
   */
  static serialize(instance: Door): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Door instance to a plain object
   */
  static toObject(instance: Door): any {
    return {
      'addTransition': instance.addTransition,
      'name': instance.name,
      'trimDoor': instance.trimDoor,
      'wallIndex': instance.wallIndex,
      'widthUOM': instance.widthUom,
      'width': instance.width,
      'isOpening': instance.isOpening,
      'offset': instance.offset,
      'shape': instance.shape?.map((item: any) =>
        PointSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of Door instances to a JSON string
   */
  static serializeArray(instances: Door[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
